export const decimalNumericRegex = /^-?\d*\.?\d*$/